export default "__VITE_PUBLIC_ASSET__213783c9__"